export const FooterData = [

    {
        heading:"Quick links",
        item:[
         {
             FItem:"About us",
             linkL:"/about"
         },
         {
             FItem:"Programs",
             linkL:"/causes"
         },
         {
             FItem:"Events",
             linkL:"/event"
         },
         {
             FItem:"News",
             linkL:"/news"
         },
         {
             FItem:"Gallery",
             linkL:"/gallery"
         },
        ]
     },
     {
        heading:"Get involved",
        item:[
         {
             FItem:"Help & FAQ",
             linkL:"/faqs"
         },
         {
             FItem:"Programs",
             linkL:"/causes"
         },
         {
             FItem:"Events",
             linkL:"/event"
         },
         {
             FItem:"Contact us",
             linkL:"/contact"
         },
         {
             FItem:"Terms of service",
             linkL:"/terms-service"
         }
        ]
     },
     
]
